import {createReducer} from '@reduxjs/toolkit';
import {
    getProjects,
    getProfiles,
    getSubmittedFeedbacks,
    getConsolidatedFeedbacks,
    saveConsolidatedFeedback
} from './actions';
import {updatePeriod} from '../../../controllers/periods/services/actions';
import {ProjectInfoDto} from '../../../dto/ProjectInfoDto';
import {ProjectProfiles, ProjectFeedbacks, ProjectGroupedFeedbacks} from '../typedef';

type InitialState = {
    projects: ProjectInfoDto[];
    projectProfiles: ProjectProfiles[];
    projectFeedbacks: ProjectGroupedFeedbacks[];
    projectConsolidatedFeedbacks: ProjectFeedbacks[];
};

const initialState: InitialState = {
    projects: [],
    projectProfiles: [],
    projectFeedbacks: [],
    projectConsolidatedFeedbacks: []
};

export const consolidatedFeedback = createReducer(initialState, (builder) =>
    builder
        .addCase(getProjects.fulfilled, (state, action) => ({...state, projects: action.payload}))
        .addCase(getProfiles.pending, (state, action) => ({
            ...state,
            projectProfiles: state.projectProfiles.filter((el) => el.projectId !== action.meta.arg)
        }))
        .addCase(getProfiles.fulfilled, (state, action) => ({
            ...state,
            projectProfiles: state.projectProfiles.concat(action.payload)
        }))
        .addCase(getSubmittedFeedbacks.pending, (state, action) => ({
            ...state,
            projectFeedbacks: state.projectFeedbacks.filter((el) => el.projectId !== action.meta.arg.projectId)
        }))
        .addCase(getSubmittedFeedbacks.fulfilled, (state, action) => ({
            ...state,
            projectFeedbacks: state.projectFeedbacks.concat(action.payload)
        }))
        .addCase(getConsolidatedFeedbacks.pending, (state, action) => ({
            ...state,
            projectConsolidatedFeedbacks: state.projectConsolidatedFeedbacks.filter(
                (el) => el.projectId !== action.meta.arg.projectId
            )
        }))
        .addCase(getConsolidatedFeedbacks.fulfilled, (state, action) => ({
            ...state,
            projectConsolidatedFeedbacks: state.projectConsolidatedFeedbacks.concat(action.payload)
        }))
        .addCase(saveConsolidatedFeedback.fulfilled, (state, action) => ({
            ...state,
            projectConsolidatedFeedbacks: state.projectConsolidatedFeedbacks.map((el) => {
                if (el.projectId === action.payload.projectId) {
                    const consolidatedFeedback = el.feedbacks.find(
                        ({recipientId}) => action.payload.recipientId === recipientId
                    );
                    return {
                        ...el,
                        feedbacks: consolidatedFeedback
                            ? el.feedbacks.map((feedback) => {
                                if (feedback.recipientId === action.payload.recipientId) {
                                    return action.payload;
                                } else {
                                    return feedback;
                                }
                            })
                            : el.feedbacks.concat(action.payload)
                    };
                } else {
                    return el;
                }
            })
        }))
        .addCase(updatePeriod.fulfilled, (state, action) => {
            const {projectId, periodId, locked} = action.payload;
            return {
                ...state,
                projects: state.projects.map((el) =>
                    el.projectId === projectId
                        ? {
                            ...el,
                            periods: el.periods.map((period) =>
                                period.id === periodId ? {...period, locked} : period
                            )
                        }
                        : el
                )
            };
        })
);
